import axios from 'axios'
import type { fw, fwfilter, fwfile, updatefw } from '../types/types'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'firmware'

export const readFwListAPI = async (page: fwfilter): Promise<fw[]> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'list',
      ...page
    }
  })
  console.log("readFwListAPI 응답:", response.data)
  return response.data.data
}

// 업로드 디랙토리 펌웨어 파일 목록
export const readFwFilesAPI = async (): Promise<fwfile[]> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'files',
    }
  })
  console.log("readFwFilesAPI 응답:", response.data)
  return response.data.data
}

export const addFwAPI = async (fwfile: fwfile[]) => {
  const filesData = fwfile.map(file => file.name);
  const response = await axios.get(`${baseurl}${url}`, { 
    params: { 
      cmd: 'add', 
      files: filesData
    },
    paramsSerializer: {
      indexes: null 
    }
  });
  
  console.log("addFwAPI 응답:", response);
  return response.data.data;
}

export const updateFwAPI = async (updatefw: updatefw): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'update',
      ...updatefw
    }
  })
  console.log("updateFwAPI 응답:", response.data)
  return response.data
}

export const deleteFWAPI = async (id: number): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'delete',
      id: id
    }
  })
  console.log("deleteFWAPI 응답:", response.data)
  return response.data
}

export const paginationFwAPI = async (page: fwfilter): Promise<number> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'pagination',
      ...page
    }
  })
  console.log("paginationFwAPI 응답:", response.data)
  return response.data.data.totalpage
}

